// app/javascript/modules/ferias/form_abono.js
// Gerencia o abono pecuniário (venda de férias) e suas regras automáticas.

export function initFeriasAbono(form) {
  const checkbox      = form.querySelector('#params_abono_pecuniario')
  const diasInput     = form.querySelector('#params_dias_a_serem_vendidos')
  const diasWrapper   = form.querySelector('[data-ferias-field="dias_vendidos"]')
  const resumoWrapper = form.querySelector('#resumo-abono-wrapper')
  const resumoInput   = form.querySelector('#resumo-dias-abono')

  function showDias(show) {
    if (!diasWrapper) return
    diasWrapper.classList.toggle('hidden', !show)
  }

  // Sincroniza o bloco de resumo (dias de abono) com o estado atual do checkbox/input
  function updateResumo() {
    const ativo = checkbox?.checked || false
    const dias  = ativo ? (parseInt(diasInput?.value || '0', 10) || 0) : 0
    if (resumoWrapper) resumoWrapper.classList.toggle('hidden', !ativo)
    if (resumoInput)   resumoInput.value = ativo ? (dias || '') : ''
  }

  function setDisabled(val) {
    if (!checkbox) return
    checkbox.disabled = val
    const label = form.querySelector('label[for="params_abono_pecuniario"]')
    if (label) label.style.opacity = val ? '0.5' : '1'
  }

  function apply() {
    showDias(checkbox?.checked || false)
    updateResumo()
  }

  function onTotalChanged(e) {
    const { total } = e.detail

    if (total >= 26 && total < 30) {
      setDisabled(false)

      // Bloqueia fracionar via evento (form_fracionamento também escuta isso)
      const fraconarCb = form.querySelector('#movimentacoes_pessoal_fracionar_ferias')
      if (fraconarCb) {
        fraconarCb.disabled = true
        const lbl = form.querySelector('label[for="movimentacoes_pessoal_fracionar_ferias"]')
        if (lbl) lbl.style.opacity = '0.5'
      }
    } else if (total >= 30) {
      // Só desabilita/desmarca quando o abono NÃO está ativo.
      if (!checkbox?.checked) {
        setDisabled(true)
        if (checkbox) { checkbox.checked = false; checkbox.disabled = true }
        showDias(false)
      }
    } else {
      setDisabled(false)
      if (checkbox?.checked && diasInput && !diasInput.value) diasInput.value = 10
    }

    updateResumo()
  }

  const onCheckboxChange = () => { apply() }
  const onDiasChange     = () => updateResumo()

  checkbox?.addEventListener('change', onCheckboxChange)
  diasInput?.addEventListener('input',  onDiasChange)
  diasInput?.addEventListener('change', onDiasChange)
  form.addEventListener('ferias:total-changed', onTotalChanged)

  apply()

  return {
    apply,
    destroy() {
      checkbox?.removeEventListener('change', onCheckboxChange)
      diasInput?.removeEventListener('input',  onDiasChange)
      diasInput?.removeEventListener('change', onDiasChange)
      form.removeEventListener('ferias:total-changed', onTotalChanged)
    }
  }
}
